import type { ReferralNeededDTO, ReferralNeeded } from '../types';

export const parseReferralNeededForFE = ({ referral_needed }: ReferralNeededDTO): ReferralNeeded => ({
  referralNeeded: referral_needed,
});
